import * as THREE from 'three';

type GranitMaterialProps = {
  map: THREE.Texture | null;
  metalness?: number;
};

/**
 * Composant réutilisable pour le matériau granit avec configuration optimisée
 * pour un rendu réaliste du granit poli
 */
export const GranitMaterial = ({ map, metalness = 0.3 }: GranitMaterialProps) => {
  return (
    <meshPhysicalMaterial
      map={map}
      // Granit n'est PAS un métal
      metalness={metalness}
      // Granit poli = surface lisse
      roughness={0.2}
      // Clearcoat pour l'effet "verni/poli"
      clearcoat={1}
      clearcoatRoughness={0.05}
      // IOR réaliste pour le quartz/granit (~1.54)
      ior={1.5}
      // Réflexions environnementales
      envMapIntensity={1}
      reflectivity={0.6}
      // Sheen pour les micro-reflets cristallins
      sheen={0.4}
      sheenRoughness={0.2}
    />
  );
};
